<section class="reporte-filtros">
  <div class="filtros__header">
    <span class="titulo">{{ reportFiltersComponent()?.title }}</span>
    <span class="icono" aria-hidden="true">
      <img src="assets/icons-reports/filtro.svg" alt="" aria-hidden="true">
    </span>
  </div>

  <label class="form-mode">{{ reportFiltersComponent()?.chooseReportTypeLabel }}</label>

  <div class="modes">
    <button type="button" class="mode" [class.mode--active]="analysisMode === 'final-assessments'"
      (click)="setMode('final-assessments')">
      <span class="mode__title">{{ reportFiltersComponent()?.generalReportOption }}</span>
    </button>

    <button type="button" class="mode" [class.mode--active]="analysisMode === 'category-scores'"
      (click)="setMode('category-scores')" [disabled]="disableCategories">
      <span class="mode__title">{{ reportFiltersComponent()?.categoryReportOption }}</span>
    </button>

    <button type="button" class="mode" [class.mode--active]="analysisMode === 'domain-scores'"
      (click)="setMode('domain-scores')">
      <span class="mode__title">{{ reportFiltersComponent()?.domainReportOption }}</span>
    </button>

    <button type="button" class="mode" [class.mode--active]="analysisMode === 'dimension-scores'"
      (click)="setMode('dimension-scores')" disabled>
      <span class="mode__title">{{ reportFiltersComponent()?.dimensionReportOption }}</span>
    </button>
  </div>


  <!-- Bloque B: Segmentación (groupBy) — ahora disponible para todos los modos -->
  <label class="form-mode">{{ reportFiltersComponent()?.demographicFiltersLabel }} </label>

  <div class="chips">
    @for (opt of groupByOptions; track opt.key) {
    <button type="button" class="chip" [class.chip--selected]="groupBy.has(opt.key)" (click)="toggleGroupBy(opt.key)">
      {{ opt.label }}
    </button>
    }
  </div>


  <div class="limpiar-container">
    <button (click)="clearGroupBy()" class="link"
            type="button">{{ reportFiltersComponent()?.cleanDemographicFiltersButton }}
    </button>
  </div>

  <label class="form-mode">{{ reportFiltersComponent()?.adjustFiltersValuesLabel }}</label>

  <div class="filtros__grid">


    <!-- Demográficos -->
    <app-filtro-select class="campo" [options]="genderOptions" [(value)]="filters.gender" placeholder="Género">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="ageRangeOptions" [(value)]="filters.ageRange"
      placeholder="Rango de edad">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="departmentOptions"
      [(value)]="filters.department"
      (valueChange)="onDepartmentChange($event)"
      [disabled]="loadingDepartment || !departmentOptions.length && !metaError"
      [placeholder]="loadingDepartment ? 'Cargando área…' : 'Área'">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="educationLevelOptions" [(value)]="filters.educationLevel"
      placeholder="Nivel educativo">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="positionOptions" [(value)]="filters.position" placeholder="Puesto">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="employeeTypeOptions" [(value)]="filters.employeeType"
      placeholder="Tipo de empleado">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="seniorityOptions" [(value)]="filters.seniority"
      placeholder="Antigüedad en puesto">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="contractTypeOptions" [(value)]="filters.contractType"
      placeholder="Tipo de contrato">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="maritalStatusOptions" [(value)]="filters.maritalStatus"
      placeholder="Estado civil">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="educationStatusOptions" [(value)]="filters.educationStatus"
      placeholder="Estatus educativo">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="occupationOptions" [(value)]="filters.occupation"
      [disabled]="loadingOccupation || (occupationOptions.length === 1 && !occupationOptions[0].value)"
      [placeholder]="occupationPlaceholder">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="workScheduleOptions" [(value)]="filters.workSchedule"
      placeholder="Horario de trabajo">
    </app-filtro-select>

    <app-filtro-select class="campo" [options]="totalWorkExperienceOptions" [(value)]="filters.totalWorkExperience"
      placeholder="Experiencia laboral total">
    </app-filtro-select>
    <app-filtro-select class="campo" [options]="hasShiftRotationOptions" [(value)]="filters.hasShiftRotation"
      placeholder="Rotación de turno">
    </app-filtro-select>
  </div>

  <div class="limpiar-container">
    <button (click)="clearGroupByFilters()" class="link"
            type="button">{{ reportFiltersComponent()?.cleanDemographicFiltersButton }}
    </button>
  </div>
</section>
